<template>
  <v-card outlined class="mx-auto s-layout-small mt-0">
    <v-card-title class="pa-0" style="justify-content: space-between;">
      <p class="ma-0">Thông tin đơn hàng</p>
      <p class="ma-0" v-if="contentOrder.isDetail && checkAuthorization('order-ctv-create_read') && !checkAuthorization('contact_read')">
        {{dataStatusCTV}}
      </p>
      <p class="ma-0" v-else>{{dataStatus}}</p>
    </v-card-title>
    <v-row>
      <v-col cols="12" sm="12" class="order-products-wrapper">
        <div class="order-module" :class="[[moduleTypes.GIA_SU, moduleTypes.IELTS_Y].includes($store.state.module.typeId) ? 'flexColumnReserve' : 'flexColumn', disable ? 'disableOrder' : '']">
          <div class="order-tutor" v-show="(orderT && orderT.length > 0) || (orderGS.length == 0 && orderT.length == 0) && $store.state.module.typeId != 2">
          <div class="order-tutor-title">SẢN PHẨM THƯỜNG</div>
         <div class="order-tutor-table">
           <table class="table-small-screen">
              <tr>
                <th style="width: 30%" class="pl-6">Tên sản phẩm</th>
                <th style="width: 7%">Số lượng</th>
                <th style="width: 13%">Thời hạn</th>
                <th style="width: 15%">Kích hoạt</th>
                <th style="width: 15%">Thành tiền</th>
                <th style="white-space: nowrap;width: 15%">Tên con</th>
                <th v-if="stepOrder !== 3"></th>
              </tr>
              <tr v-for="(product, index) in orderT" :key="index">
                <td class="order-active px-6">
                    <v-autocomplete
                      :disabled="isReadOnly || stepOrder === 3 || product.disable || codeOrder === 'ĐHT'"
                      v-model="product.productId"
                      :items="getNotGS()"
                      item-text="name"
                      item-value="idTemp"
                      :class="[product.activeTypeOrder === 3 ?  'mt-36px' : '', 'ma-0 pa-0']"
                      @change="changeProductT(product, index)"
                      item-disabled="disable"
                      :label="product.product && product.product.status == 'inactive' ? product.product.name : ''"
                    />
                </td>
                <td class="pr-6">
                  <validation-provider
                      v-slot="{ errors }"
                      name="Số lượng"
                      :vid="'Số lượng' + index"
                      :rules="{numeric: true, regex: /^[0-9]+$/, min_value:1, max:4 }"
                    >
                    <v-text-field
                      :readonly="isReadOnly || stepOrder === 3"
                      type="number"
                      v-model="product.quantity"
                      label
                      :class="[product.activeTypeOrder === 3 ?  'mt-36px' : '', 'ma-0 pa-0']"
                      color="primary"
                      @input="changeQuantity('T',product, index)"
                      :disabled="product.disable || codeOrder === 'ĐHT'"
                      :error-messages="errors"
                    />
                    </validation-provider>
                    <span v-show="product.quantity > 1" class="warning-spt"><i>(Thời hạn của sản phẩm thường, sẽ không được nhân theo số lượng)</i></span>
                </td>
                <td class="pr-6">
<!--                  <validation-provider-->
<!--                    v-slot="{ errors }"-->
<!--                    name="Đơn giá"-->
<!--                    :vid="'Đơn giá' + index"-->
<!--                    :rules="{required: true, numeric: true, regex: /^[0-9]+$/, min_value:0}"-->
<!--                  >-->
<!--                    <v-text-field-->
<!--                      :readonly="isReadOnly || stepOrder === 3"-->
<!--                      step="5000"-->
<!--                      type="number"-->
<!--                      v-model="product.price"-->
<!--                      label-->
<!--                      class="ma-0 pa-0"-->
<!--                      :error-messages="errors"-->
<!--                      color="primary"-->
<!--                    />-->
<!--                  </validation-provider>-->
<!--                  <v-currency-field-->
<!--                      class="ma-0 pa-0"-->
<!--                      readonly-->
<!--                      :value="(product.intoMoney / product.quantity)"-->
<!--                  />-->
                        <v-text-field
                          readonly
                          v-model="product.endMonth"
                          label
                          :class="[product.activeTypeOrder === 3 ?  'mt-36px' : '', 'ma-0 pa-0']"
                          color="primary"
                          :disabled="product.disable || codeOrder === 'ĐHT'"
                          suffix="(Tháng)"
                        />
                </td>
                  <td class="pr-6">
                      <validation-provider
                              v-slot="{ errors }"
                              name="Phương thức kích hoạt"
                              :rules="{required: true }"
                              :immediate="false"
                              :vid="`activeTypeOrder${index}`"
                      >
                      <v-select
                              :ref="`activeTypeOrder${index}`"
                              :disabled="isReadOnly || !product.productId || stepOrder === 3 || product.disable || codeOrder === 'ĐHT' || product.isDisable"
                              v-model="product.activeTypeOrder"
                              :items="product.listActiveType"
                              item-text="name"
                              item-value="id"
                              :error-messages="errors"
                              @change="changeProductTypeActive(product, $event)"
                              :class="['ma-0 pa-0',  product.activeTypeOrder === 3 ? 'select-active-type' : '']"
                              :menu-props="{ top: true, offsetY: true , maxHeight: 200}"
                      >
                          <template v-slot:selection="{ item }">
                              <b>{{ getTextActivated(item.id) }}</b>
                          </template>
                      </v-select>
                      </validation-provider>
                      <div v-show="product.activeTypeOrder === 3">
                          <v-menu

                                  ref="datePickerMenu"
                                  v-model="datePickerMenu[orderT.indexOf(product)]"
                                  :close-on-content-click="false"
                                  :return-value.sync="product.activeDate"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                          >
                              <template v-slot:activator="{ on }">
                                  <validation-provider
                                          v-slot="{ errors }"
                                          name="Chọn ngày"
                                          :rules="{required: product.activeTypeOrder === 3 }"
                                          :immediate="false"
                                          :vid="`endDate-day${index}`"
                                  >
                                      <v-text-field
                                              :disabled="isReadOnly || !product.productId || stepOrder === 3 || product.disable || codeOrder === 'ĐHT' || product.isDisable"
                                              class="text-field-date-order"
                                              placeholder="--"
                                              style="margin-left: -4px;padding-top: 0 !important;margin-top: 0 !important;"
                                              v-model="product.activeDate"
                                              color="primary"
                                              :error-messages="errors"
                                              prepend-icon="mdi-calendar-outline"
                                              readonly
                                              v-on="on"
                                              clearable
                                      />
                                  </validation-provider>
                              </template>
                              <v-date-picker
                                      v-model="product.activeDate"
                                      color="secondary"
                                      scrollable
                                      @change="$refs.datePickerMenu[index].save(product.activeDate), datePickerMenu[orderT.indexOf(product)] = false"
                                      :min="currentDate"
                              >
                              </v-date-picker>
                          </v-menu>
                      </div>
                  </td>
                <td class="pr-6">
                    <v-text-field
                        :readonly="isReadOnly || stepOrder === 3"
                        type="number"
                        v-model="product.intoMoney"
                        label
                        :class="[product.activeTypeOrder === 3 ?  'mt-36px' : '', 'ma-0 pa-0']"
                        color="primary"
                        @input="changeIntoMoney('T', product, index)"
                        :disabled="codeOrder === 'ĐHT'"
                    />
<!--                  <v-currency-field-->
<!--                      class="ma-0 pa-0"-->
<!--                      :readonly="isReadOnly || stepOrder === 3"-->
<!--                      :value="(product.price * product.quantity)"-->
<!--                  />-->
                </td>
                <td :style="product.customerId ? '' : 'padding-top: 13px !important'">
                    <v-autocomplete
                      :disabled="isReadOnly || !product.productId || stepOrder === 3 || product.disable || codeOrder === 'ĐHT'"
                      v-model="product.customerId"
                      :items="sortData(childCustomers)"
                      item-text="fullName"
                      item-value="id"
                      :class=" ['ma-0 pa-0', product.activeTypeOrder === 3 ?  'mt-36px' : '']"
                    >
                      <template v-slot:item="{ active, item, attrs, on }">
                        <v-list-item v-on="on" v-bind="attrs">
                          <v-list-item-content>
                            <v-list-item-title>
                              <div  style="font-weight: 500;margin-bottom: 2px;"> {{ item.fullName }}</div>
                              <div v-if="item.userName" style="font-style: italic;font-size: 12px;margin-bottom: 2px">(<span style="font-weight: 500">  Tài khoản: {{ item.userName }} </span></div>
                              <div v-if="item.userName" style="font-style: italic;font-size: 12px;">Đơn tạo gần nhất: {{ item.order ? item.order : 'chưa có' }} )</div>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  <div v-if="!product.customerId" style="color:red; font-size: 11px !important;font-style: italic; margin-top: -18px !important;">
                    Vui lòng chọn con đã có tài khoản (Nếu có)
                  </div>
                </td>
                 <td class="text-center" style="position: relative">
                    <div :class="['delete-order', product.activeTypeOrder === 3 ?  'mt-36px' : '']" v-if="stepOrder !== 3" v-show="!isReadOnly && codeOrder !== 'ĐHT'" @click="onClickRemoveProduct('T', index)">
                      <b>Xoá</b>
                    </div>
                  </td>
              </tr>
        </table>
         <div class="tfool-total">
            <div class="tfool-total-name" style="width: 63%; justify-content: right;">
              <div class="total-price pr-6">
                <b>TỔNG:</b>
              </div>
            </div>
            <div  class="pl-1"><b class="price-color"> {{formatPrice(totalPriceT, 'đ')}}</b></div>
         </div>
         </div>
          </div>
          <div class="order-tutor" v-show="(orderGS && orderGS.length > 0) || (orderGS.length == 0 && orderT.length == 0) && $store.state.module.typeId == 2">
            <div class="order-tutor-title">SẢN PHẨM GIA SƯ</div>
            <div class="order-tutor-table">
              <table class="table-small-screen mobile-hidden">
                  <tr>
                    <th style="width: 11%"  class="pl-6">Loại đơn</th>
                    <th style="width: 15%">Chương trình</th>
                    <th style="width: 10%">Loại giáo viên</th>
                    <th style="width: 10%">Gói</th>
                    <th style="width: 15%">Chọn sản phẩm</th>
                    <th  style="width: 7%">Số lượng</th>
                    <th style="width: 8%">Thành tiền</th>
                    <th style="white-space: nowrap;width: 15%">Tên con</th>
                    <th v-if="stepOrder !== 3"></th>
                  </tr>
                  <tr v-for="(product, index) in orderGS" :key="index">
                    <td class="order-active px-6">
                        <v-autocomplete
                          :disabled="isReadOnly || stepOrder === 3 || product.disable || codeOrder === 'ĐHT'"
                          v-model="product.orderType"
                          :items="order"
                          item-text="name"
                          item-value="id"
                          class="ma-0 pa-0"
                          item-disabled="disable"
                        />
                    </td>
                    <td class="pr-6">
<!--                        <v-autocomplete-->
<!--                          :items="SUBJECTS_SORT_CLASS"-->
<!--                          item-text="lowCaseName"-->
<!--                          item-value="code"-->
<!--                          label-->
<!--                          class="ma-0 pa-0"-->
<!--                          color="primary"-->
<!--                          :disabled="product.disable || codeOrder === 'ĐHT'"-->
<!--                          v-model="product.product.monCode"-->
<!--                          @change="resetOrder(product.product.monCode, index)"-->
<!--                        />-->
                      <v-autocomplete
                          :items="listProgram"
                          item-text="title"
                          item-value="id"
                          label
                          class="ma-0 pa-0"
                          color="primary"
                          :disabled="product.disable || codeOrder === 'ĐHT'"
                          v-model="product.product.curriculumId"
                          @change="(event) =>handleChangeCurriculum(event, index)"
                      />
                    </td>
                    <td class="pr-6">
                        <v-autocomplete
                          :items="getLoaiGv(product.product.monCode)"
                          item-text="name"
                          item-value="id"
                          label
                          class="ma-0 pa-0"
                          color="primary"
                          :disabled="product.disable || codeOrder === 'ĐHT'"
                          v-model="product.product.teacherType"
                          @change="resetOrder(product.product.teacherType, index)"
                        />
                    </td>
                    <td class="css-gs pr-6">
                        <v-autocomplete
                            :readonly="isReadOnly || stepOrder === 3"
                            class="ma-0 pa-0"
                            color="primary"
                            :disabled="codeOrder === 'ĐHT'"
                            v-model="product.selectedPackage"
                            :items="getGOI(product.product.monCode, product.product.teacherType,  product.product.curriculumId)"
                            item-text="nameGoi"
                            item-value="package"
                            @change="(event) =>changePackage(product, index)"
                            :label="product.product && product.product.status == 'inactive' ? `1-${product.product.classType} : ${product.product.numberOfSection} buổi` : ''"
                        />
                    </td>
                      <td class="css-gs pr-6">
                          <v-autocomplete
                                  :readonly="isReadOnly || stepOrder === 3 || !product.selectedPackage"
                                  class="ma-0 pa-0"
                                  color="primary"
                                  :disabled="codeOrder === 'ĐHT'"
                                  v-model="product.productId"
                                  :items="getListProduct(product.product.monCode, product.selectedPackage, product.product.teacherType,  product.product.curriculumId)"
                                  item-text="name"
                                  item-value="idTemp"
                                  @change="changeProductGS(product, index)"
                                  :label="product.product && product.product.status == 'inactive' ? `${product.product.name}` : ''"
                          />
                      </td>
                    <td class="pr-6">
                      <validation-provider
                          v-slot="{ errors }"
                          name="Số lượng"
                          :vid="`quantity${index}`"
                          :rules="{numeric: true, regex: /^[0-9]+$/, min_value:1, max_value_1_1: [product, courseRegisters, 30] }"
                        >
                        <v-text-field
                            :ref="`quantity${index}`"
                            :readonly="isReadOnly || stepOrder === 3"
                            type="number"
                            label
                            class="ma-0 pa-0"
                            color="primary"
                            @input="changeQuantity('GS',product, index)"
                            v-model="product.quantity"
                            :error-messages="errors"
                            :disabled="codeOrder === 'ĐHT'"
                        />
                        </validation-provider>
                    </td>
                    <td class="pr-6">
                        <v-text-field
                            :readonly="isReadOnly || stepOrder === 3"
                            type="number"
                            label
                            class="ma-0 pa-0"
                            color="primary"
                            @input="changeIntoMoney('GS',product, index)"
                            v-model="product.intoMoney"
                            :disabled="codeOrder === 'ĐHT'"
                        />
                    </td>
                    <td :style="product.customerId ? '' : 'padding-top: 13px !important'">
                        <v-autocomplete
                          :disabled="isReadOnly || !product.productId || stepOrder === 3 || product.disable || codeOrder === 'ĐHT'"
                          v-model="product.customerId"
                          :items="sortData(childCustomers)"
                          item-text="fullName"
                          item-value="id"
                          class="ma-0 pa-0 name-children"

                        >
                          <template v-slot:item="{ active, item, attrs, on }">
                            <v-list-item v-on="on" v-bind="attrs">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <div  style="font-weight: 500;margin-bottom: 2px;"> {{ item.fullName }}</div>
                                  <div v-if="item.userName" style="font-style: italic;font-size: 12px;margin-bottom: 2px">(<span style="font-weight: 500">  Tài khoản: {{ item.userName }} </span></div>
                                  <div v-if="item.userName" style="font-style: italic;font-size: 12px;">Đơn tạo gần nhất: {{ item.order ? item.order : 'chưa có' }} )</div>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      <div v-if="!product.customerId" style="color:red; font-size: 11px !important;font-style: italic; margin-top: -18px !important;">
                        Vui lòng chọn con đã có tài khoản (Nếu có)
                      </div>
                    </td>
                    <td  class="text-center" style="position: relative">
                      <div class="delete-order" v-show="!isReadOnly && codeOrder !== 'ĐHT' && stepOrder !== 3" @click="onClickRemoveProduct('GS', index)">
                        <b
                        >Xoá</b>
                        </div>
                    </td>
                  </tr>
              </table>
              <div class="tfool-total">
                  <div class="tfool-total-name" style="width: 63%; justify-content: right;">
                    <div class="total-price pr-6">
                      <b>TỔNG: </b>
                    </div>
                  </div>
                    <div class="pl-1"><b class="price-color">{{formatPrice(totalPriceGS, 'đ')}}</b></div>
                </div>
            </div>
          </div>
        </div>
        <div class="tfool-total"  style="background: #FFF">
            <div class="tfool-total-name" style="width: 63%; justify-content: right;">
              <div class="total-price pr-6">
                <b>TỔNG GIÁ TRỊ ĐƠN HÀNG:</b>
              </div>
            </div>
            <div  class="pl-1"><b class="price-color"> {{formatPrice((totalPriceT + totalPriceGS), 'đ')}}</b></div>
         </div>
        <div style="text-align: left;">
            <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="blue" v-bind="attrs" v-on="on" small v-show="stepOrder !== 3 && !isReadOnly && codeOrder !== 'ĐHT'" :disabled="disable">
                <v-icon>mdi-plus</v-icon>Thêm sản phẩm
              </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item) in listTypeOrder"
                    :key="item.value"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="onClickAddProduct(item.value)">{{ item.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

        </div>
        <div class="order-deposit mt-5" v-if="(mode === 'create') || (mode === 'edit' && !_.isEmpty(listTrail))" :class="{'disableOrder' : disable}">
          <div class="deposit-name" style="width: 63%">
            <div  class="deposit-checkbox">
              <div class="deposit-checkbox mr-5">
                <v-checkbox v-model="statusDepositOne"
                            :disabled="
                            statusDepositTwo ||
                            codeOrder === 'ĐHT' ||
                            (mode == 'edit' && listTrail.groupOrderData && listTrail.groupOrderData.length > 1 && (statusOrderCompleted.type == 'T3' || statusOrderCompleted.type == 'C3' || statusOrderCompleted.type == 'T5' || statusOrderCompleted.type == 'T5')) ||
                            (mode === 'edit' && cloneOrderType == 'DCHL')
                      ">
                </v-checkbox>
                <b :class="statusDepositTwo ? 'activeCheckbox' : ''">Đặt cọc trước tiền</b>
              </div>
            <div class="deposit-checkbox">
              <v-checkbox
                  @change="changeStatusDepositTwo()"
                  v-model="statusDepositTwo"
                  :disabled="
                  statusDepositOne ||
                 codeOrder === 'ĐHT' ||
                 (mode == 'edit' && listTrail.groupOrderData && listTrail.groupOrderData.length > 1 && (statusOrderCompleted.type == 'T3' || statusOrderCompleted.type == 'C3' || statusOrderCompleted.type == 'T5' || statusOrderCompleted.type == 'T5')) ||
                 (mode === 'edit' && cloneOrderType == 'DCHL')
              ">
              </v-checkbox>
              <b :class="statusDepositOne ? 'activeCheckbox' : ''">Đặt cọc học luôn</b>
            </div>
            </div>
            <div class="total-price pr-6" v-if="statusDepositOne || statusDepositTwo">
              <b>TIỀN CỌC: </b>
            </div>
          </div>
          <div class="pl-1" v-if="statusDepositOne || statusDepositTwo">
            <validation-provider
              v-show="stepOrder >= 2"
              v-slot="{ errors }"
              name="TIỀN CỌC"
              :rules="{
                required: true,
                min_value: 0,
                max_value: (totalPriceGS + totalPriceT),
              }"
            >
              <!-- <v-text-field
                type="number"
                class="price-input-deposit"
                color="green"
                v-model="priceDeposit" dense :error-messages="errors" :disabled="codeOrder === 'ĐHT'" suffix="đ"
                @input="countNeedMoney"
                ></v-text-field> -->
                <v-currency-field
                  :readonly="contactStatus.type == 'T5' || contactStatus.type == 'C5'"
                  class="price-input-deposit"
                  v-model="priceDeposit" dense :error-messages="errors" :disabled="codeOrder === 'ĐHT'" suffix="đ"
                  @keyup="changePriceDeposit"
                  @change="handlePriceDeposit"
                  color="green"
                />
            </validation-provider>
          </div>
        </div>
        <div class="order-deposit mb-4" v-if="codeOrder == 'ĐHT'" :class="{'disableOrder' : disable}">
          <div class="deposit-name" style="width: 63%">
            <div  class="deposit-checkbox">
            </div>
            <div class="total-price pr-6" v-if="statusDepositOne || statusDepositTwo">
              <b>CẦN THANH TOÁN TIẾP: </b>
            </div>
          </div>
          <div class="pl-1" v-if="statusDepositOne || statusDepositTwo">
            <!-- <v-text-field dense class="need-input-deposit" :disabled="codeOrder == 'ĐHT'" v-model="needMoney" suffix="đ">
            </v-text-field> -->
            <v-currency-field
              dense
              class="need-input-deposit"
              :disabled="codeOrder == 'ĐHT'" v-model="needMoney" suffix="đ"
            />
          </div>
        </div>
         <div class="order-module order-deposit" v-if="statusDepositTwo" :class="{'disableOrder' : disable}">
          <div v-show="(orderHT && orderHT.length > 0) || (orderHTProductInactive && orderHTProductInactive.length)">
            <div class="order-tutor-table">
              <table class="table-small-screen mobile-hidden">
                  <tr>
                    <th style="width: 40%"  class="pl-6">{{ codeOrder == 'ĐHT' ? 'HOÀN TẤT GÓI' : 'CHỌN GÓI HỌC THỬ'}}</th>
                    <th style="width: 25%"> {{ codeOrder == 'ĐHT' ? ' SỐ BUỔI / THÁNG HOÀN TẤT HỌC THỬ' : ' SỐ BUỔI/THÁNG QUY ĐỔI CỌC'}}</th>
                    <th style="width: 10%"></th>
                    <th style="width: 25%">TÊN CON</th>
                  </tr>
                  <tr v-for="(product, index) in orderHT" :key="index">
                    <td class="order-active px-6">
                      <div class="order-deposit-names"> {{showGoiHT(product)}}</div>
                    </td>
                    <td class="css-gs pr-6">
                         <validation-provider
                          v-slot="{ errors }"
                          name="Số buổi/tháng"
                          :vid="'Số buổi/tháng' + index"
                          :rules="{required: true, numeric: true, regex: /^[0-9]+$/, min_value:0, max:4 }"
                        >
                        <v-text-field
                            v-if="codeOrder !== 'ĐHT'"
                            :readonly="isReadOnly || stepOrder === 3"
                            type="number"
                            label
                            class="ma-0 pa-0"
                            color="primary"
                           @input="changeQuantity('HT',product, index)"
                            v-model="product.quantity"
                            :error-messages="errors"
                            :disabled="priceDeposit == 0"
                            dense
                        />
                         <v-text-field
                            v-if="codeOrder === 'ĐHT'"
                            :readonly="isReadOnly || stepOrder === 3"
                            type="number"
                            label
                            class="ma-0 pa-0"
                            color="primary"
                           @input="changeQuantity('HTĐHT',product, index)"
                            v-model="product.resQuanty"
                            :error-messages="errors"
                            :disabled="codeOrder == 'ĐHT'"
                            dense
                        />
                        </validation-provider>
                    </td>
                    <td style="width: 100px"> {{ product.productType == 'GIA_SU' ? '(Buổi)' : '(Tháng)' }}</td>
                    <td>
                      {{ product.customerId ? childCustomers.find(item => item.id === product.customerId).fullName : ''  }}
                    </td>
                  </tr>

                  <tr v-for="(product, index) in orderHTProductInactive" :key="'inactive-' + index">
                    <td class="order-active px-6">
                      <div class="order-deposit-names"> {{ showGoiHT(product) }}</div>
                    </td>
                    <td class="css-gs pr-6">
                      <v-text-field
                          v-if="codeOrder !== 'ĐHT'"
                          disabled
                          type="number"
                          label
                          class="ma-0 pa-0"
                          color="primary"
                          v-model="product.quantity"
                          dense
                      />
                      <v-text-field
                          v-if="codeOrder === 'ĐHT'"
                          disabled
                          type="number"
                          label
                          class="ma-0 pa-0"
                          color="primary"
                          v-model="product.resQuanty"
                          dense
                      />
                    </td>
                    <td style="width: 100px"> {{ product.productType == 'GIA_SU' ? '(Buổi)' : '(Tháng)' }}</td>
                  </tr>
              </table>
              <div class="total-price-deposit" v-if="codeOrder !== 'ĐHT'">Tiền quy đổi  : {{formatPrice(totalPriceTrail, 'đ')}}</div>
            </div>
          </div>
        </div>
        <v-expansion-panels class="mb-4 mobile-show" v-model="panel" multiple>
          <v-expansion-panel style="border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;">
            <v-expansion-panel-header class="px-0" id="support-filter-header"><b>Thông tin sản phẩm</b></v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list-item three-line class="overflow-visible pa-0">
                <v-list-item-content class="overflow-visible pa-0">
                  <div v-for="(product, index) in contentOrder.products" :key="`1${index}`" class="my-3" style="border-bottom: 1px solid black">
                    <div v-if="stepOrder !== 3 && !isReadOnly && index > 0" style="text-align: right; margin-right: 10px;">
                      <v-btn
                        style="margin-right: -20px;"
                        @click="onClickRemoveProduct(index)"
                        text
                        small
                      >
                        <v-icon>mdi-close-box</v-icon>
                      </v-btn>
                    </div>
                      <v-autocomplete
                        :disabled="isReadOnly || stepOrder === 3"
                        v-model="product.productId"
                        :items="getNotGS()"
                        item-text="name"
                        item-value="idTemp"
                        label="Tên sản phẩm"
                        class="ma-0 pa-0 mb-3"
                        @change="changeProduct(product, index)"
                      />
                      <validation-provider
                        v-slot="{ errors }"
                        name="Số lượng"
                        :vid="'Số lượng' + index"
                        :rules="{numeric: true, regex: /^[0-9]+$/, min_value:1, max:4 }"
                      >
                        <v-text-field
                          :readonly="isReadOnly || stepOrder === 3"
                          type="number"
                          v-model="product.quantity"
                          label="Số lượng"
                          class="ma-0 pa-0 mb-3"
                          color="primary"
                          @input="changeQuantity(product, index)"
                          :error-messages="errors"
                        />
                      </validation-provider>
<!--                    <validation-provider-->
<!--                      v-slot="{ errors }"-->
<!--                      name="Đơn giá"-->
<!--                      :vid="'Đơn giá' + index"-->
<!--                      :rules="{required: true, numeric: true, regex: /^[0-9]+$/, min_value:0}"-->
<!--                    >-->
<!--                      <v-text-field-->
<!--                        :readonly="isReadOnly || stepOrder === 3"-->
<!--                        step="5000"-->
<!--                        type="number"-->
<!--                        v-model="product.price"-->
<!--                        label="Đơn giá"-->
<!--                        class="ma-0 pa-0 mb-3"-->
<!--                        :error-messages="errors"-->
<!--                        color="primary"-->
<!--                      />-->
<!--                    </validation-provider>-->
                    <v-text-field
                        readonly
                        step="5000"
                        v-model="product.price"
                        label
                        class="ma-0 pa-0"
                        color="primary"
                    />
<!--                    <v-currency-field class="ma-0 pa-0" readonly :value="(product.price * product.quantity)" />-->
                      <v-text-field
                          :readonly="isReadOnly || stepOrder === 3"
                          type="number"
                          v-model="product.intoMoney"
                          label
                          class="ma-0 pa-0"
                          color="primary"
                          @input="changeIntoMoney(product, index)"
                      />
                      <v-autocomplete
                        :disabled="isReadOnly || !product.productId || stepOrder === 3"
                        v-model="product.customerId"
                        :items="sortData(childCustomers)"
                        item-text="fullName"
                        item-value="id"
                        class="ma-0 pa-0 name-children"
                        label="Tên con sử dụng"
                      />
                    <div v-if="stepOrder !== 3" v-show="index > 0 && !isReadOnly" class="text-left" style="position: relative">

                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <div>
                <v-btn small v-if="stepOrder !== 3 && !isReadOnly" class="add-product-btn px-0" @click="onClickAddProduct">
                  <v-icon>mdi-plus</v-icon><span class="add-product-text">Thêm sản phẩm</span>
                </v-btn>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="12" class="pb-0">
        <!-- <validation-provider
          v-show="stepOrder >= 2"
          v-slot="{ errors }"
          name="Đã thanh toán"
          :rules="{
            required: true,
            min_value: 0,
            max_value: totalPrice,
          }"
        >
          <v-currency-field
            :readonly="isReadOnly || stepOrder === 3"
            label="Đã thanh toán"
            :error-messages="errors"
            :disabled="codeOrder === 'ĐHT'"
            class="ma-0 pa-0"
            v-model="contentOrder.paidAmount"
          />
        </validation-provider> -->
        <v-currency-field v-if="false" readonly label="Còn lại" :value="restPrice" :disabled="codeOrder === 'ĐHT'"/>
        <validation-provider v-slot="{ errors }" name="Hình thức thanh toán" rules="required">
          <v-autocomplete
            :disabled="isReadOnly || stepOrder === 3"
            v-model="contentOrder.paymentType"
            :items="orderPaymentTypes"
            label="Hình thức thanh toán *"
            class="ma-0 pa-0"
            :error-messages="errors"
          />
        </validation-provider>
        <validation-provider v-slot="{ errors }" name="Ghi chú đơn hàng" rules="max:255">
          <v-textarea
            :readonly="isReadOnly || stepOrder === 3"
            label="Ghi chú đơn hàng"
            rows="3"
            class="ma-0 pa-0"
            v-model="contentOrder.description"
            :error-messages="errors"
          />
        </validation-provider>
        <validation-provider v-slot="{ errors }" name="Note cho vận hành xếp lớp" rules="max:255">
          <v-textarea
            :readonly="isReadOnly || stepOrder === 3"
            label="Note cho vận hành xếp lớp"
            rows="3"
            class="ma-0 pa-0"
            v-model="contentOrder.noteSortClass"
            :error-messages="errors"
          />
        </validation-provider>
        <!-- <v-autocomplete
          v-if="!contentOrder.isDetail"
          :readonly="isReadOnly || stepOrder === 3"
          v-model="contentOrder.statusId"
          :items="getStatusList"
          item-text="name"
          item-value="id"
          label="Trạng thái"
        /> -->
      </v-col>
      <v-col cols="12" sm="12" class="py-0">
        <ul class="table-info">
          <li class="mb-2">
            <strong>Địa chỉ người nhận</strong>
          </li>
          <li class="mb-1">
            <p class="ma-0">
              <span class="font-weight-medium">Số điện thoại :</span>
              {{fullNamePhone}}
              <v-tooltip v-if="showChat" bottom>
                <template v-slot:activator="{ on }">
                    <v-btn class="icon-fb" icon small color="info" v-on="on"><v-icon>mdi-facebook-messenger</v-icon></v-btn>
                </template>
                <span>Nhắn tin</span>
            </v-tooltip>
            </p>
          </li>
          <li class="mb-1">
            <p class="ma-0">
              <span class="font-weight-medium">Địa chỉ :</span>
              {{_.get(shippingAddress, 'detailAddress', '')}}
            </p>
          </li>
          <li class="mb-1">
            <p class="ma-0">{{provinceAddress}}</p>
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import {orderPaymentTypes, SUBJECTS_SORT_CLASS, LOAI_GIAOVIEN, listActiveTypeOrder} from '../../../helpers/constants';
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ProgramRepository = RepositoryFactory.get('program');
import moment from 'moment'
import { moduleTypes } from '../../../helpers/constants';

export default {
  props: {
    dataForm: {
      type: Object,
      default: () => {}
    },
    contentOrder: {
      type: Object,
      default: () => {}
    },
    contactStatus: {
      type: Object,
      default: () => ({})
    },
    contactStatusList: {
      type: Array,
      default: () => []
    },
    shippingAddress: {
      type: Object,
      default: () => {}
    },
    courseRegisters: {
      type: Array,
      default: () => []
    },
    childCustomers: {
      type: Array,
      default: () => []
    },
    stepOrder: {
      type: Number,
      default: -1
    },
    showChat: {
      type: Boolean,
      default: false
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    contactId: {
      type: Number,
      default: () => null
    },
    codeOrder: {
      type: String,
      default: () => ''
    },
    listTrail: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: () => ''
    },
    disable: {
      type: Boolean,
      default: () => false
    },
    statusOrderCompleted: {
        type: Object,
        default: () => {}
    }

  },
  data() {
    return {
      totalPriceOld: 0,
      datePickerMenu: [],
      listActiveTypeOrder,
      orderPaymentTypes,
      panel: [0],
      // timeOrderTutor: null,
      listOrderDisable: [],
      listOrderTutor: [],
      SUBJECTS_SORT_CLASS,
      LOAI_GIAOVIEN,
      orderGS : [],
      orderT: [],
      order: [
        {
          id: 1,
          name: 'Đơn mới'
        },
        {
          id: 2,
          name: 'Gia hạn'
        },
      ],
      statusDepositOne: false,
      statusDepositTwo: false,
      orderHT: [],
      totalPriceTrail: 0,
      priceDeposit: null,
      dataLoadedGS: false,
      dataLoadedT: false,
      dataLoaded2: false,
      needMoney: null,
      listTypeOrder: [
        {
          text: 'Sản phẩm gia sư',
          value: 'GS'
        },
        {
          text: 'Sản phẩm thường',
          value: 'T'
        }
      ],
      HTOrderGS: [],
      HTOrderT: [],
      gsRemoved: [],
      thuongRemoved: [],
      listProgram: [],
      attrs: [
        'id',
        'title',
        'code',
        'subject_id'
      ],
      moduleTypes,
      orderHTProductInactive: [],
      cloneOrderType: '',
    };
  },
  async created() {
    await this.getListProgram()
    if (this.mode === 'create') {
      this.statusDepositTwo = true;
    }
    this.checkGS();
    this.checkT();
    const newOrderT = this.orderT.map((orderItem) => {
      const foundProduct = _.find(this.courseRegisters, o2 => orderItem.productId === o2.idTemp);
      if(foundProduct?.endDate) {
        orderItem.endMonth = Math.round(moment(foundProduct.endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(this.contentOrder.createdAt, 'YYYY-MM-DD HH:mm:ss'), 'months', true))
        orderItem.numberOfSection = Math.round(moment(foundProduct.endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(this.contentOrder.createdAt, 'YYYY-MM-DD HH:mm:ss'), 'months', true))
      }
      if(foundProduct?.endMonth) {
        orderItem.endMonth = foundProduct.endMonth;
        orderItem.numberOfSection = foundProduct.endMonth;
      }
      if(!_.isEmpty(foundProduct?.products)) {
        if(foundProduct.products[0].endDate) {
          orderItem.endMonth = Math.round(moment(foundProduct.products[0].endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(this.contentOrder.createdAt, 'YYYY-MM-DD HH:mm:ss'), 'months', true))
          orderItem.numberOfSection = Math.round(moment(foundProduct.products[0].endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(this.contentOrder.createdAt, 'YYYY-MM-DD HH:mm:ss'), 'months', true))
        }
        if(foundProduct.products[0].endMonth) {
          orderItem.endMonth = foundProduct.products[0].endMonth;
          orderItem.numberOfSection = foundProduct.products[0].endMonth;
        }
      }
      return orderItem;
    });
    const newArr = _.concat(this.orderGS, newOrderT);
    let result = _.map(newArr, (o1) => {
      const foundProduct = _.find(this.courseRegisters, o2 => o1.productId === o2.idTemp);
      if (!foundProduct && o1?.product?.status == 'inactive') { // sản phẩm inactive
        let productIdArr = o1.productId.split('-');
        let id = productIdArr && productIdArr.length == 2 ? +productIdArr[1] : ''
        this.orderHTProductInactive.push({
          id,
          orderType: o1.orderType,
          quantity: o1.quantity,
          customerId: o1.customerId,
          prices: o1.price,
          quantityGS: o1.quantity,
          numberOfSection: o1.numberOfSection || o1?.product?.numberOfSection,
          classType: o1?.product?.classType,
          name: o1?.product?.name,
          status: o1?.product?.status,
          productType: o1?.productType,
          monCode: o1?.product?.monCode,
          teacherType: o1?.product?.teacherType
        })
      }
      return {...foundProduct, orderType: o1.orderType, quantity: o1.quantity, customerId: o1.customerId, prices: o1.price, quantityGS: o1.quantity, numberOfSection: o1.numberOfSection || foundProduct?.numberOfSection};
    })

    result = result.filter(s => s.id && s.customerId);
    result = this.removeDuplicates(result)
    const listTrail = _.get(this.listTrail, 'trailProductData', []);
    const listTrailGroup = _.get(this.listTrail, 'groupOrderData', []);
    this.dataLoadedGS = true;
    this.dataLoadedT = true;
    if (!_.isEmpty(listTrail)) {
      // let newData= []
       this.orderHT = _.map(result, (item) => {
        const foundItem = _.find(listTrail, (i) => i.productId === item.id && item.customerId === i.customerId)
        return {
          ...item,
          quantity: foundItem?.trailLessons ? foundItem?.trailLessons : 0,
          intoMoney: foundItem?.money ? foundItem?.money : 0,
          resQuanty: item.numberOfSection * item.quantity - (foundItem?.trailLessons ? foundItem?.trailLessons : 0),
        }
      });
      this.statusDepositTwo = true;
      //
      this.orderT = _.map(this.orderT, (item) => {
        const foundItem = _.find(listTrail, (i) => `combo-${i.productId}` == item.productId || `product-${i.productId}` == item.productId)
        return {...item,  endMonth: item.endMonth ? item.endMonth : (foundItem?.trailLessons ? foundItem?.trailLessons : 0) }
      });
      this.orderHTProductInactive = _.map(this.orderHTProductInactive, (item) => {
        const foundItem = _.find(listTrail, (i) => i.productId == item.id)
        if (item.productType != 'GIA_SU') {
          if (foundItem && foundItem?.product?.endDate) {
            item.numberOfSection = Math.round(moment(foundItem.endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(this.contentOrder.createdAt, 'YYYY-MM-DD HH:mm:ss'), 'months', true))
          } else if (foundItem && foundItem?.product?.endMonth) {
            item.numberOfSection = foundItem?.product?.endMonth
          }
        }
        return {
          ...item,
          quantity: foundItem?.trailLessons ? foundItem?.trailLessons : 0,
          intoMoney: foundItem?.money ? foundItem?.money : 0,
          resQuanty: item.numberOfSection * item.quantity - (foundItem?.trailLessons ? foundItem?.trailLessons : 0)
        }
      });
    } else {
      this.orderHT = [];
      if(!_.isEmpty(listTrailGroup)) {
        this.statusDepositOne = true;
      }
    }
    if (!_.isEmpty(this.orderHT)) {
      this.orderHT = this.orderHT.filter(item => item.classType === 1 && item.orderType === 1 || item.orderType === 2 || item.orderType === 0 || item.orderType == undefined )
    }
    if(this.$route.query.codeOrder && this.$route.query.codeOrder == 2) {
      this.priceDeposit = this.contentOrder.totalPrice;
    }else {
      if(this.codeOrder == 'ĐC') {
        this.priceDeposit = this.contentOrder.totalPrice;
      }
      if(this.codeOrder == 'ĐHT') {
        this.priceDeposit = (this.totalPriceGS +  this.totalPriceT) - this.contentOrder.totalPrice;
      }
    }
    this.totalPriceOld = this.totalPriceT + this.totalPriceGS
    this.countNeedMoney();
    this.totalPriceHT();
    if(this.mode == 'edit') {
        if(this.statusDepositOne) {
            this.cloneOrderType =  'DCTT'
        }
        if(this.statusDepositTwo) {
            this.cloneOrderType =  'DCHL'
        }
    }
  },
  watch: {
    orderGS : {
      handler(val) {
        const result = _.map(val, (o1) => {
          const foundProduct = _.find(this.courseRegisters, o2 => o2.idTemp === o1.productId && o1.orderType === 1 && o2.classType  === 1 ||  o2.idTemp === o1.productId && o1.orderType === 2);
          return {...foundProduct, orderType: o1.orderType, customerId: o1.customerId, prices: o1.price, quantityGS: o1.quantity};
        })
        const allProduct = _.map(val, (o1) => {
          const foundProduct = _.find(this.courseRegisters, o2 => o2.idTemp === o1.productId)
          return {...foundProduct, orderType: o1.orderType, customerId: o1.customerId, prices: o1.price, quantityGS: o1.quantity};
        })
        if(allProduct.length > 0) {
          const dataCheckIeltsY= allProduct.filter(item => item.group && item.group.schoolLevelId == 7 && item.group.typeId == 6)
          const isCheckIeltsY = dataCheckIeltsY.length > 0
          Bus.$emit('checkIeltsY-GS', isCheckIeltsY)
        }else {
          Bus.$emit('checkIeltsY-GS', false)
        }
        if (!this.dataLoadedGS) {
            let isDisablepriceDeposit = false
            if(this.contactStatus && this.contactStatus.type == 'C5' || this.contactStatus && this.contactStatus.type == 'T5') {
                isDisablepriceDeposit = true
            }
            if(!isDisablepriceDeposit) {
                this.priceDeposit = null
            }
          let flagIsChangeData = false;
          this.HTOrderGS = result.filter(s => s.id && s.customerId);
          const hTOrderMerged = this.HTOrderGS.concat(this.HTOrderT);
          const orderTMapped = hTOrderMerged.map((itemT) => {
            return {
              productId: itemT.idTemp ? itemT.idTemp : itemT.productId,
              classType: itemT.classType,
              orderType: itemT.orderType,
              nameGoi: itemT.nameGoi,
              customerId: itemT.customerId
            };
          });
          const orderTIds = orderTMapped.map(itemT => itemT.idTemp ? itemT.idTemp : itemT.productId);
          this.orderHT.forEach((itemOrderHT, indexHT) => {
            if (itemOrderHT.productType === 'GIA_SU') {
              if (!orderTIds.includes(itemOrderHT.idTemp)) {
                flagIsChangeData = true;
                this.orderHT.splice(indexHT, 1);
              }
            }
          });

          this.orderHT = this.orderHT.map(item => {
            const orderType = orderTMapped.find(e => e.productId == item.idTemp)?.orderType || item.orderType;
            return {
              ...item,
              orderType
            }
          })
          const newData = [];

          hTOrderMerged.forEach((item) => {
            let flag = false;
            this.orderHT.forEach((itemHT) => {
              if (item.id === itemHT.id && item.customerId === itemHT.customerId) {
                flag = true;
              }
            });
            if (!flag) {
              newData.push(item);
            }
          });
          this.orderHT.forEach((data, index) => {
              if(!this.HTOrderGS.some(item => item.customerId === data.customerId) && data.productType === 'GIA_SU') {
                this.orderHT.splice(index,1)
              }
          });
          if (newData.length) {
            flagIsChangeData = true;
            this.orderHT = this.orderHT.concat(newData);
          }
          if (flagIsChangeData) {
            this.orderHT.forEach(item => item.quantity = null);
          }

          // if(_.isEmpty(val) && this.mode !== 'edit') {
          //   this.statusDepositOne = false
          // }
        }
        if(_.isEmpty(val) && this.mode !== 'edit') {
          this.statusDepositOne = false
        }
        this.dataLoadedGS = false;

        this.countNeedMoney();
      },
      deep: true,
    },
    orderT : {
      handler(val) {
        let flagIsChangeData = false;
        const result = _.map(val, (o1, key) => {
          const foundProduct = _.find(this.courseRegisters, o2 => o2.idTemp === o1.productId);
            // CRMINTER-2183
            let listActiveType= []
            if(foundProduct && foundProduct.activeType.length) {
                listActiveType = this.listActiveTypeOrder.filter(item => foundProduct.activeType.includes(item.id))
            }
          return {
                ...foundProduct,
                customerId: o1.customerId,
                prices: o1.price,
                quantityGS: o1.quantity,
                numberOfSection: o1.numberOfSection,
                listActiveType: listActiveType
            };
        //  end CRMINTER-2183
        })
        if(result.length > 0) {
          let dataProduct = []
          result.forEach(item => {
            if(item.products && item.products.length > 0) {
              item.products.forEach(itemProduct => {
                dataProduct.push(itemProduct)
              })
            }else {
              dataProduct.push(item)
            }
          })
          if(dataProduct.length > 0) {
            const dataCheckIeltsY= dataProduct.filter(item => item.group && item.group.schoolLevelId == 7 && item.group.typeId == 6)
            const isCheckIeltsY = dataCheckIeltsY.length > 0
            Bus.$emit('checkIeltsY-T', isCheckIeltsY)
          }
        }else {
          Bus.$emit('checkIeltsY-T', false)
        }
        if (!this.dataLoadedT) {
            let isDisablepriceDeposit = false
            if(this.contactStatus && this.contactStatus.type == 'C5' || this.contactStatus && this.contactStatus.type == 'T5') {
                isDisablepriceDeposit = true
            }
            if(!isDisablepriceDeposit) {
                this.priceDeposit = null
            }
          this.HTOrderT = result.filter(s => s.id && s.customerId);
          const hTOrderTMerged = this.HTOrderT.concat(this.HTOrderGS);
          const newData = [];
          hTOrderTMerged.forEach((item) => {
            let flag = false;
            this.orderHT.forEach((itemHT) => {
              if (item.id === itemHT.id && item.customerId === itemHT.customerId) {
                flag = true;
              }
            });
            if (!flag) {
              newData.push(item);
            }
          });

          this.orderHT.forEach((data, index) => {
            if(!this.HTOrderT.some(item => item.customerId === data.customerId) && data.productType !== 'GIA_SU') {
              this.orderHT.splice(index,1)
            }
          });

          const orderTIds = hTOrderTMerged.map(itemT => itemT.idTemp ? itemT.idTemp : itemT.productId);
          this.orderHT.forEach((itemOrderHT, indexHT) => {
            if (itemOrderHT.productType != 'GIA_SU') {
              if (!orderTIds.includes(itemOrderHT.idTemp)) {
                flagIsChangeData = true;
                this.orderHT.splice(indexHT, 1);
              }
            }
          });

          if (newData.length) {
            flagIsChangeData = true;
            this.orderHT = this.orderHT.concat(newData);
          }
          // if(_.isEmpty(val) && this.mode !== 'edit') {
          //   this.statusDepositOne = false
          //   this.statusDepositTwo = false
          // }
        }
        if(_.isEmpty(val) && this.mode !== 'edit') {
          this.statusDepositOne = false
          this.statusDepositTwo = false
        }
        if (flagIsChangeData) {
          this.orderHT.forEach(item => item.quantity = null);
        }
        this.dataLoadedT = false;
        this.countNeedMoney();
      },
      deep: true,
    },
  },
  computed: {
    currentDate () {
      return moment().format('YYYY-MM-DD')
    },
    getStatusList() {
      let charFirstType =
        _.get(this.contactStatus, 'type', 'T').charAt(0) || 'T';
      const contactStatusList = [];
      const checkType = {};
      this.contactStatusList.forEach(contactStatus => {
        const typeContactStatus = contactStatus.type;
        if (typeContactStatus.includes(charFirstType)) {
          if (!checkType[typeContactStatus]) {
            checkType[typeContactStatus] = true;
            if (contactStatusList.length > 0) {
              contactStatusList.push({ divider: true });
            }
            contactStatusList.push({ header: typeContactStatus });
          }
          contactStatusList.push(contactStatus);
        }
      });
      return contactStatusList;
    },
    dataStatus() {
      return `Trạng thái: (${_.get(this.contactStatus, 'type', '')}-${_.get(
        this.contactStatus,
        'name',
        ''
      )})`;
    },
    dataStatusCTV() {
      return `Trạng thái: (${_.get(
          this.contactStatus,
          'name',
          ''
      )})`;
    },
    restPrice() {
      if(this.statusDepositOne || this.statusDepositTwo) {
        if (this.codeOrder === 'ĐHT') return this.needMoney;
        return +this.priceDeposit;
      }else {
        return this.totalPrice - Number(this.contentOrder.paidAmount);
      }
    },
    fullNamePhone() {
      return `${_.get(this.shippingAddress, 'receiver', '')} - ${_.get(
        this.shippingAddress,
        'phone',
        ''
      )}`;
    },
    provinceAddress() {
      return `${_.get(this.shippingAddress, 'xaName', '')} ${_.get(
        this.shippingAddress,
        'huyenName',
        ''
      )} ${_.get(this.shippingAddress, 'tinhName', '')}`;
    },
    totalPrice() {
      if(this.statusDepositOne || this.statusDepositTwo) {
        return this.priceDeposit;
      }else {
        return (
        this.orderGS.concat(this.orderT).reduce(
          (accumulator, product) => {
            return (
              accumulator +
              // _.get(product, 'price', 0) * _.get(product, 'quantity', 0)
              parseInt(_.get(product, 'intoMoney', 0))
            );
          },
          0
        ) || 0
      );
      }
    },
    totalPriceGS() {
      return (
       this.orderGS.reduce(
          (accumulator, product) => {
            return (
              accumulator +
              // _.get(product, 'price', 0) * _.get(product, 'quantity', 0)
              parseInt(_.get(product, 'intoMoney', 0))
            );
          },
          0
        ) || 0
      );
    },
    totalPriceT() {
      return (
        this.orderT.reduce(
          (accumulator, product) => {
            return (
              accumulator +
              // _.get(product, 'price', 0) * _.get(product, 'quantity', 0)
              parseInt(_.get(product, 'intoMoney', 0))
            );
          },
          0
        ) || 0
      );
    },
  },
  methods: {
    removeDuplicates(array) {
      const seen = new Set();
      return array.filter(item => {
        const key = `${item.customerId}-${item.id}`;
        if (seen.has(key)) {
          return false;
        } else {
          seen.add(key);
          return true;
        }
      });
    },
    changeStatusDepositTwo() {
      if(this.statusDepositTwo && this.mode == 'edit' ) {
        const cloneOrderSPT = _.cloneDeep(this.orderT)
        const cloneOrderSPGS = _.cloneDeep(this.orderGS)
        this.checkOrderSPT(cloneOrderSPT)
        this.checkOrderSPGS(cloneOrderSPGS)
      }
    },
    handlePriceDeposit() {
      if( this.orderHT &&  this.orderHT.length) {
        this.orderHT.forEach(item => item.quantity = null);
        this.totalPriceTrail = 0
      }
    },
      checkOrderSPGS(orderSPGS) {
              const result = _.map(orderSPGS, (o1) => {
                  const foundProduct = _.find(this.courseRegisters, o2 => o2.idTemp === o1.productId && o1.orderType === 1 && o2.classType  === 1 ||  o2.idTemp === o1.productId && o1.orderType === 2);
                  return {...foundProduct, orderType: o1.orderType, customerId: o1.customerId, prices: o1.price, quantityGS: o1.quantity};
              })
              if (!this.dataLoadedGS) {
                  let flagIsChangeData = false;
                  this.HTOrderGS = result.filter(s => s.id);
                  const hTOrderMerged = this.HTOrderGS.concat(this.HTOrderT);
                  const orderTMapped = hTOrderMerged.map((itemT) => {
                      return {
                          productId: itemT.idTemp ? itemT.idTemp : itemT.productId,
                          classType: itemT.classType,
                          orderType: itemT.orderType,
                          nameGoi: itemT.nameGoi,
                          customerId: itemT.customerId
                      };
                  });
                  this.orderHT = this.orderHT.map(item => {
                      const orderType = orderTMapped.find(e => e.productId == item.idTemp)?.orderType || item.orderType;
                      return {
                          ...item,
                          orderType
                      }
                  })
                  const newData = [];
                  hTOrderMerged.forEach((item) => {
                    let flag = false;
                    this.orderHT.forEach((itemHT) => {
                      if (item.id === itemHT.id && item.customerId === itemHT.customerId) {
                        flag = true;
                      }
                    });
                    if (!flag) {
                      newData.push(item);
                    }
                  });
                  this.orderHT.forEach((data, index) => {
                    if(!this.HTOrderGS.some(item => item.customerId === data.customerId) && data.productType === 'GIA_SU') {
                      this.orderHT.splice(index,1)
                    }
                  });
                  if (newData.length) {
                      flagIsChangeData = true;
                      this.orderHT = this.orderHT.concat(newData);
                  }
                  if (flagIsChangeData) {
                      this.orderHT.forEach(item => item.quantity = null);
                  }
              }
              this.dataLoadedGS = false;
              this.countNeedMoney();
      },
      checkOrderSPT(orderSPT) {
          let flagIsChangeData = false;
          const result = _.map(orderSPT, (o1, key) => {
              const foundProduct = _.find(this.courseRegisters, o2 => o2.idTemp === o1.productId);
              return {
                  ...foundProduct,
                  customerId: o1.customerId,
                  prices: o1.price,
                  quantityGS: o1.quantity,
                  numberOfSection: o1.numberOfSection,
              };
              if (result.length > 0) {
                  let dataProduct = []
                  result.forEach(item => {
                      if (item.products && item.products.length > 0) {
                          item.products.forEach(itemProduct => {
                              dataProduct.push(itemProduct)
                          })
                      } else {
                          dataProduct.push(item)
                      }
                  })
              }
            })
            if (!this.dataLoadedT) {
              this.HTOrderT = result.filter(s => s.id && s.customerId);
              const hTOrderTMerged = this.HTOrderT.concat(this.HTOrderGS);
              const newData = [];
              hTOrderTMerged.forEach((item) => {
                let flag = false;
                this.orderHT.forEach((itemHT) => {
                  if (item.id === itemHT.id && item.customerId === itemHT.customerId) {
                    flag = true;
                  }
                });
                if (!flag) {
                  newData.push(item);
                }
              });
              this.orderHT.forEach((data, index) => {
                if(!this.HTOrderT.some(item => item.customerId === data.customerId) && data.productType !== 'GIA_SU') {
                  this.orderHT.splice(index,1)
                }
              });
              if (newData.length) {
                flagIsChangeData = true;
                this.orderHT = this.orderHT.concat(newData);
              }
            }
            if (flagIsChangeData) {
                this.orderHT.forEach(item => item.quantity = null);
            }
            this.dataLoadedT = false;
            this.countNeedMoney();
    },
    sortData(customersTemp) {
      if(customersTemp.length) {
        return _.sortBy(customersTemp, [
          (obj) => /^\d+$/.test(obj.userName) && obj.order ? 0 : 1,
          (obj) => /^\d+$/.test(obj.userName) && !obj.order ? 2 : 3,
          (obj) => /^\w+\d+\w+$/.test(obj.userName) && obj.order ? 4 : 5,
          (obj) => /^\w+\d+\w+$/.test(obj.userName) && !obj.order ? 6 : 7,
          'id'
        ])
      }
    },
    getTextActivated(id) {
        if(id) {
            return this.listActiveTypeOrder.find(item => item.id === id).content
        }
        return  ''
    },
  attrsDataUrl(dataRequest) {
    let data = "";
    dataRequest.forEach((item) => {
      data += "&attrs[]=" + item;
    });
    return data;
  },
   async getListProgram() {
      const respond = await ProgramRepository.listProgramApi(this.attrsDataUrl(this.attrs),
          {limit: 1000 , 'filters[$eq__status]': 1,})
      if (_.get(respond, 'success', false)) {
        this.listProgram = _.get(respond, 'data', []).map(item => {
          return {
            ...item,
            subject_id : item.subject_id == 3 ? 5 : item.subject_id
          }
        })
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
     changePriceDeposit() {
      if (this.dataLoaded2) {
          // const result = _.map(this.orderGS.concat(this.orderT), (o1) => {
          //   const foundProduct = _.find(this.courseRegisters, o2 => o2.idTemp === o1.productId && o2.classType == 1);
          //   return {...foundProduct, orderType: o1.orderType, customerId: o1.customerId, prices: o1.price, quantityGS: o1.quantity};
          // })
          // this.orderHT = result.filter(s => s.id);

          this.totalPriceHT();
          // if(_.isEmpty(this.orderHT)) {
          //   this.statusDepositTwo = false;
          // }
          this.countNeedMoney();
          // if(_.isEmpty(this.orderGS)) {
          //   this.statusDepositOne = false
          //   this.statusDepositTwo = false
          // }
      }
      this.dataLoaded2 = true;
    },
    countNeedMoney() {
      // let totalPrice = this.orderGS.concat(this.orderT).reduce((accumulator, product) => {
      //   return accumulator + parseInt(_.get(product, 'intoMoney', 0))
      // }, 0) || 0;

      let totalPrice = this.totalPriceT + this.totalPriceGS
      this.needMoney = totalPrice - this.priceDeposit;
    },
    totalPriceHT(index) {
      if(_.isEmpty(this.orderHT)) {return}
      const money = this.orderHT.reduce(
          (accumulator, product) => {
            if(product.productType == 'GIA_SU') {
              return (
                accumulator +
                parseInt(_.get(product, 'intoMoney', 0))
              );
            }else {
              return (
                accumulator +
                parseInt(_.get(product, 'intoMoney', 0))*1.5
              );
            }
          },
          0
        ) || 0;
      if (money > this.priceDeposit) {
        this.$swal({
          text: 'Tiền quy đổi phải nhỏ hơn tiền cọc!',
          type: 'error',
          timer: 1500
        });
        this.totalPriceTrail = 0
        this.orderHT[index].quantity = null
        return;
      }
      this.totalPriceTrail = money
    },
    onClickRemoveProduct(value, index) {
      this.$swal({
        title: 'Xóa sản phẩm',
        text: 'Bạn có thực sự muốn xoá ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy bỏ'
      }).then(async result => {
        if (result.value) {
          if(value == 'GS') {
            this.gsRemoved.push(this.orderGS[index]);
            this.orderGS.splice(index, 1);
          }
          if(value == 'T') {
            this.thuongRemoved.push(this.orderT[index]);
            this.orderT.splice(index, 1);
          }
        }
      });
    },
    onClickAddProduct(value) {
      if(value == 'GS') {
         this.orderGS.push({
          productId: '',
          orderType: '',
          quantity: 1,
          price: 0,
          customerId: '',
          intoMoney: 0,
          product: {
            monCode: '',
            teacherType: '',
          }
        })
      };
      if(value == 'T') {
         this.orderT.push({
          productId: '',
          quantity: 1,
          price: 0,
          customerId: '',
          intoMoney: 0,
          endMonth: '',
          listActiveType: [],
          activeType: [],
          activeTypeOrder: null,
          activeDate: null,
        });
      }
    },
    changeProduct(product, index) {
      const productTemp = product;
      const data = this.courseRegisters.find(
        courseRegister => courseRegister.idTemp === productTemp.productId
      );
      productTemp.customerId = '';
      productTemp.price = data.price;
      this.contentOrder.products[index].intoMoney = product.price * product.quantity
    },
    changeProductGS(product, index) {
      const productTemp = product;
      const data = this.courseRegisters.find(
        courseRegister => courseRegister.idTemp === productTemp.productId
      );
      productTemp.customerId = '';
      productTemp.price = data.price;
      this.orderGS[index].intoMoney = product.price * product.quantity
    },
    changeProductTypeActive(product, event) {
      product.activeTypeOrder = event
      if(event === 3) {
        product.activeDate= null
      }

    },
    changeProductT(product, index) {
      const productTemp = product;
      const data = this.courseRegisters.find(
        courseRegister => courseRegister.idTemp === productTemp.productId
      );
      productTemp.customerId = '';
      productTemp.price = data.price;
      if(data?.products && !data.activeType.length) {
        this.$swal({
          title: 'Sản phẩm này không có phương thức kích hoạt',
          text: "Vui lòng xét phương thức kích hoạt cho sản phẩm",
          timer: 3000,
        });
      }
      // CRMINTER-2183
      this.orderT[index].activeType = data.activeType;
      this.orderT[index].listActiveType = this.listActiveTypeOrder.filter(item => productTemp.activeType.includes(item.id))
      if( this.orderT[index].listActiveType.filter(item => item.id == 1).length) {
        this.orderT[index].activeTypeOrder= 1
      }else {
        this.orderT[index].activeTypeOrder= null
      }
      if(this.mode == 'edit') {
        this.orderT[index].isDisable = false
      }
      // end CRMINTER-2183
      this.orderT[index].intoMoney = product.price * product.quantity;
      if(data.endDate) {
        const checkMonth =  Math.round(moment(data.endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'months', true))
        if(checkMonth < 0) {
          this.$swal({
            title: 'Sản phẩm này đã hết hạn !',
            confirmButtonText: 'Đồng ý',
            timer: 1500,
          });
          this.orderT.splice(index, 1)
        }else {
          this.orderT[index].endMonth = Math.round(moment(data.endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'months', true))
          this.orderT[index].numberOfSection = Math.round(moment(data.endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'months', true))
        }
      }
      if(data.endMonth) {
        const checkMonth = data.endMonth;
        if(checkMonth < 0) {
          this.$swal({
            title: 'Sản phẩm này đã hết hạn !',
            confirmButtonText: 'Đồng ý',
            timer: 1500,
          });
          this.orderT.splice(index, 1)
        }else {
          this.orderT[index].endMonth = data.endMonth;
          this.orderT[index].numberOfSection = data.endMonth;
        }
      }
      if(!_.isEmpty(data.products)) {
        if(data.products[0].endDate) {
          const checkMonth = Math.round(moment(data.products[0].endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'months', true))
          if(checkMonth < 0) {
            this.$swal({
              title: 'Sản phẩm này đã hết hạn !',
              confirmButtonText: 'Đồng ý',
              timer: 1500,
            });
            this.orderT.splice(index, 1)
          }else {
            this.orderT[index].endMonth = Math.round(moment(data.products[0].endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'months', true))
            this.orderT[index].numberOfSection = Math.round(moment(data.products[0].endDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'months', true))
          }
        }
        if(data.products[0].endMonth) {
          const checkMonth = data.products[0].endMonth
          if(checkMonth < 0) {
            this.$swal({
              title: 'Sản phẩm này đã hết hạn !',
              confirmButtonText: 'Đồng ý',
              timer: 1500,
            });
            this.orderT.splice(index, 1)
          }else {
            this.orderT[index].endMonth = data.products[0].endMonth;
            this.orderT[index].numberOfSection = data.products[0].endMonth;
          }
        }
      }
    },
    changeQuantity(value, product, index) {
      if(value == 'GS') {
        this.orderGS[index].intoMoney = product.price * product.quantity
      }
      if(value == 'T') {
        this.orderT[index].intoMoney = product.price * product.quantity
      }
      if(value == 'HT') {
        if(!this.priceDeposit) {
           this.$swal({
            type: 'error',
            title: 'Cần nhập tiền cọc!',
            timer: 1500
          });
          this.orderHT[index].quantity = null
          return
        }
        this.orderHT[index].intoMoney =  Math.floor((product.prices/product.numberOfSection) * Number(product.quantity));
        if(this.codeOrder == 'ĐHT') {
          this.orderHT[index].intoMoney =  Math.floor((product.prices/product.numberOfSection) * Number(product.resQuanty));
        }
        this.orderHT[index].resQuanty = (this.orderHT[index].numberOfSection*this.orderHT[index].quantityGS) - this.orderHT[index].quantity;
        this.totalPriceHT(index);
      }
    },
    changeIntoMoney(value, product, index) {
      if(value == 'GS') {
        this.orderGS[index].price = Math.round(+product.intoMoney / +product.quantity)
        // const result = _.map(this.orderGS.concat(this.orderT), (o1) => {
        //   const foundProduct = _.find(this.courseRegisters, o2 => o2.idTemp === o1.productId && o2.classType == 1);
        //   return {...foundProduct, orderType: o1.orderType, customerId: o1.customerId, price: o1.price};
        // });
        // this.orderHT = result.filter(s => s.id);
      }
      if(value == 'T') {
        this.orderT[index].price = Math.round(+product.intoMoney / +product.quantity)
      }
      if(value == 'HT') {
        this.orderHT[index].price = Math.round(+product.intoMoney / +product.quantity)
      }
    },
    checkGS() {
      this.orderGS = _.filter(this.contentOrder.products, function(product) { return product.productType && product.productType == 'GIA_SU' });
      this.orderGS.map(item => {
        if(item.product) {
          item.selectedPackage = `${item.product.classType}-${item.product.numberOfSection}`
        }
      })
    },
    checkT() {
      this.orderT = _.filter(this.contentOrder.products, function(product) { return !product.productType || product.productType != 'GIA_SU' });
    },
    getGOI(monCode, teacherType,curriculumId) {
      // let checkGoi = _.filter(this.courseRegisters, function(item) {
      //   if (monCode.toUpperCase() == 'TA') {
      //     return item.monCode && item.monCode.toUpperCase() == monCode.toUpperCase() && item.teacherType == teacherType && item.productType == 'GIA_SU'
      //   } else {
      //     return item.monCode && item.monCode.toUpperCase() == monCode.toUpperCase() && item.productType == 'GIA_SU'
      //   }
      // })
      let checkGoi = monCode.toUpperCase() == 'TA' ?
        _.filter(this.courseRegisters, item => item.curriculumId && item.curriculumId == curriculumId && item.productType == 'GIA_SU' && item.teacherType == teacherType) :
        _.filter(this.courseRegisters, item => item.curriculumId && item.curriculumId == curriculumId && item.productType == 'GIA_SU')
      checkGoi.map(s => {
        s.nameGoi = `1-${s.classType} : ${s.numberOfSection} buổi`
        s.package = `${s.classType}-${s.numberOfSection}`
      })
      return checkGoi
    },
    getListProduct(monCode,selectedPackage, teacherType,curriculumId) {
     if(selectedPackage) {
       const data = selectedPackage ? selectedPackage.split('-') : []
       return  monCode.toUpperCase() == 'TA' ? _.filter(this.courseRegisters, item => item.curriculumId && item.curriculumId == curriculumId
         && item.productType == 'GIA_SU' && item.teacherType == teacherType && item.classType == data[0] && item.numberOfSection == data[1])
         :  _.filter(this.courseRegisters, item => item.curriculumId && item.curriculumId == curriculumId && item.productType == 'GIA_SU'
           && item.classType == data[0] && item.numberOfSection == data[1])
     }
      return []
    },
    getNotGS() {
      let checkNotGoi = _.filter(this.courseRegisters, function(item) { return item.productType != 'GIA_SU'})
      return checkNotGoi
    },
    getLoaiGv(monCode) {
      if (monCode.toLowerCase() == 'ta') {
        return LOAI_GIAOVIEN
      } else {
        return [LOAI_GIAOVIEN[0]]
      }
    },
    handleChangeCurriculum(data, index) {
      if(data) {
        const monID = this.listProgram.filter(item => item.id == data)[0].subject_id
        this.orderGS[index].product.monCode = SUBJECTS_SORT_CLASS.filter(item => item.id === monID)[0].code
        this.orderGS[index].productId = '';
        this.orderGS[index].intoMoney = '';
        this.orderGS[index].customerId = '';
      }
    },
    changePackage(product, index) {
      if(product.selectedPackage) {
        const dataProduct = this.getListProduct(product.product.monCode, product.selectedPackage, product.product.teacherType,  product.product.curriculumId)
        product.productId = dataProduct.length ? dataProduct[0].idTemp : ''
        this.changeProductGS(product, index)
      }
    },
    resetOrder(value, index) {
      this.orderGS[index].productId = '';
      this.orderGS[index].intoMoney = '';
      this.orderGS[index].customerId = '';
    },
    showGoiHT(product) {
      if(product.productType != 'GIA_SU'){ return product.name}

      let name = ''
      this.order.map(s => {
        if(s.id == product.orderType) {
          name = s.name
        }
      })
      this.SUBJECTS_SORT_CLASS.map(s => {
        if(s.code == product.monCode) {
          name = name + ' - ' + s.lowCaseName
        }
      })
       this.LOAI_GIAOVIEN.map(s => {
        if(s.id == product.teacherType) {
          name = name + ' - ' + s.name
        }
      })
      return name + ' : ' + '1-' + product.classType + ' : ' + product.numberOfSection + ' buổi'
    },
  }
};
</script>

<style scoped>
::v-deep .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}

.add-product-btn {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #2196F3 !important;
  box-shadow: unset;
  text-underline-position: under;
  font-weight: bold;
}

.add-product-btn .add-product-text {
  text-decoration: underline;
  text-underline-position: under;
}

.delete-product-btn {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #F44336 !important;
  box-shadow: unset;
  text-underline-position: under;
  font-weight: bold;
  position: absolute;
  right: 20px;
}

.delete-product-btn .delete-product-text {
  text-decoration: underline;
  text-underline-position: under;
}
::v-deep .order-active label.v-label.v-label--active.theme--light.primary--text {
    display: none;
}
.order-tutor-title {
    background: #F7F7FC;
    border-radius: 3px 3px 0px 0px;
    height: 24px;
    font-family: Roboto;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: left;
    display: flex;
    align-items: center;
    padding-left: 20px;
    padding-top: 3px;
}
::v-deep .order-tutor table {
    background: #FAFAFA;
}
::v-deep .order-deposit table {
    height: 113px;
}

.order-tutor {
    margin-bottom: 10px;
}
.order-tutor-table {
    overflow: auto;
    max-width: 100%;
    background: #FDF6E2;
}
tr.tfool-total {
    position: relative;
}

.total-price {
    /* position: absolute;
    left: 216px;
    display: flex;
    bottom: 15px;
    align-items: center; */
    font-size: 13px;
}
::v-deep .css-gs label.v-label.v-label--active.theme--light.primary--text {
    display: none;
}
table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
}
table tr td {
    position: relative;
    padding-bottom: 10px;
    border-top: 1px solid #cfcfcf;
}
.order-deposit table tr td {
    border-top: none;
}
table tr:hover td {
    background: #f3f3f3;
}
.tfool-total {
    display: flex;
    background: #FAFAFA;
    padding: 10px 20px;
    align-items: center;
}
.tfool-total-name {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.add-order {
    width: 100%;
    justify-content: right;
    display: flex;
}
table tr th {
  text-align: left;
}
.order-module {
  display: flex;
}
.flexColumn {
  flex-direction: column;
}
.flexColumnReserve {
  flex-direction: column-reverse;
}
.delete-order {
    color: #2196f3;
    cursor: pointer;
    margin-bottom: 7px;
    font-size: 13px;
}
.price-color {
    color: #FD1F6D;
}
.order-deposit {
    display: flex;
    align-items: center;
}

.deposit-name {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.deposit-checkbox {
    display: flex;
    align-items: center;
}
b.activeCheckbox {
    color: #BDBDBD;
}
.total-price-deposit {
    font-family: Roboto;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: left;
    display: flex;
    justify-content: right;
    padding: 25px;
    color: #828282;
}
::v-deep .price-input-deposit input {
  color:  #008000 !important;
  font-weight: 700 !important;
  font-size: 14px !important;
}
::v-deep .need-input-deposit input {
  color:  #FD1F6D !important;
  font-weight: 700 !important;
  font-size: 14px !important;
}
.disableOrder {
  pointer-events: none;
}
::v-deep .order-module .v-text-field__suffix {
    font-size: 13px;
}
.warning-spt {
    font-size: 11px;
    position: absolute;
    width: 81%;
    top: 36px;
    line-height: 1;
    color: red;
}
.mt-36px {
    margin-top: -36px !important;
}

</style>
<style>
.select-active-type .v-text-field__details {
    display: none !important;
}
.text-field-date-order .v-input__prepend-outer{
    margin-top: 9px !important;
}
</style>